import * as RequestUtil from '../utils/RequestUtil';
import { FileInfoBO, PreviewBO } from '../model/BO/FileBO';
import { DriveUrl, PreviewUrl } from '../constants/UrlConstant';
import { isMobileClient } from '../utils/CommonUtil';
import { transUrl } from '../utils/UrlUtil';

const isMock = false;
export const notQTClient = navigator.userAgent.toLocaleLowerCase().indexOf('qingtui') < 0;

export function getFileInfo(shareId: string): Promise<FileInfoBO> {
  if (isMock) {
    return new Promise((resolve, reject) => {
      return resolve({
        contentType: 'dfadsf',
        domainId: '',
        fileName:
          '需求文档放假啊收到了房间的撒开飞机卢萨卡独家发售短发都是垃圾发多少放假啊独领风骚的减肥拉的思考方式打击.doc',
        fileId: 'dfasd',
        size: 123,
        shareName: '飞燕房间萨里发生',
        expire: false,
        expireType: 2,
        permission: 3,
        shareId: 'xfdafs',
        shareOpen: true,
        scanUrl: '',
      });
    });
  }
  if (isMobileClient() && !notQTClient) {
    return new Promise((resolve, reject) => {
      (window as any).qt.ajax({
        url: transUrl('/api' + DriveUrl + '/share/open/file/detail'),
        type: RequestUtil.Method.GET,
        data: { shareOpenId: shareId },
        success: (data: any) => {
          if (data.result.data) {
            resolve(data.result.data);
          } else if (data.result.code) {
            reject({
              code: data.result.code,
            });
          }
        },
        fail: (e: any) => {
          reject({
            code: e.statusCode,
            message: e.message,
          });
        },
      });
    });
  }
  return RequestUtil.sendRequest({
    url: DriveUrl + '/share/open/file/detail',
    method: RequestUtil.Method.GET,
    data: {
      shareOpenId: shareId,
    },
  }).then((res) => {
    return res.data || {};
  });
}

export function getPreviewConfig(): Promise<PreviewBO> {
  if (isMock) {
    return new Promise((resolve, reject) => {
      return resolve({
        fileLimitSize: 124,
        previewDomain: 'https://preview.qingtui.cn',
        supports: ['doc'],
      });
    });
  }
  if (isMobileClient() && !notQTClient) {
    return new Promise((resolve, reject) => {
      (window as any).qt.ajax({
        url: transUrl('/api' + PreviewUrl + '/preview/config'),
        type: RequestUtil.Method.GET,
        // data: {shareOpenId: shareId},
        success: (data: any) => {
          if (data.result.data) {
            resolve(data.result.data);
          } else if (data.result.code) {
            reject({
              code: data.result.code,
            });
          }
        },
        fail: (e: any) => {
          reject({
            code: e.statusCode,
            message: e.message,
          });
        },
      });
    });
  }
  return RequestUtil.sendRequest({
    url: PreviewUrl + '/preview/config',
    method: RequestUtil.Method.GET,
  }).then((res) => {
    return res.data;
  });
}

// 下载

export function getDownloadFileUrl(fileId: string, domainId?: string) {
  if (isMobileClient() && !notQTClient) {
    return new Promise((resolve, reject) => {
      (window as any).qt.ajax({
        url: transUrl('/api' + DriveUrl + '/file/signature/download/url'),
        type: RequestUtil.Method.GET,
        data: { fileId: fileId },
        header: {
          DomainId: domainId || '',
        },
        success: (data: any) => {
          if (data.result.data) {
            resolve(data.result.data);
          } else if (data.result.code) {
            reject({
              code: data.result.code,
            });
          }
        },
        fail: (e: any) => {
          reject({
            code: e.statusCode,
            message: e.message,
          });
        },
      });
    });
  }
  return RequestUtil.sendRequest({
    url: DriveUrl + '/file/signature/download/url',
    method: RequestUtil.Method.GET,
    headers: {
      DomainId: domainId || '',
    },
    data: {
      fileId,
    },
  }).then((res) => {
    return res.data || '';
  });
}

// 打开

export function getOpenFileUrl(fileId: string, domainId?: string) {
  if (isMobileClient() && !notQTClient) {
    return new Promise((resolve, reject) => {
      (window as any).qt.ajax({
        url: transUrl('/api' + DriveUrl + '/file/teamwork/open'),
        type: RequestUtil.Method.GET,
        data: { fileId: fileId },
        header: {
          DomainId: domainId || '',
        },
        success: (data: any) => {
          if (data.result.data) {
            resolve(data.result.data);
          } else if (data.result.code) {
            reject({
              code: data.result.code,
            });
          }
        },
        fail: (e: any) => {
          reject({
            code: e.statusCode,
            message: e.message,
          });
        },
      });
    });
  }
  return RequestUtil.sendRequest({
    url: DriveUrl + '/file/teamwork/open',
    method: RequestUtil.Method.GET,
    data: {
      fileId,
    },
    headers: {
      DomainId: domainId || '',
    },
  }).then((res) => {
    return res.data || '';
  });
}

// 短信发送类型
export enum SMSSendType {
  SMS_LOGIN = 1, // 短信登录
}
// 短信登录步骤
export enum SMSStepType {
  INPUT_PHONE = 'input_phone', // 输入手机号 第一步
  VALIDATE_CODE = 'validateCode', //  验证 验证吗 第二步
  RESEND_VALIDATE_CODE = 'resend_validate_code', // 重新发送验证码的时候，第三步，不一定会出现
}
// 短信发送实体类
export interface SMSSendModel {
  countryCode: string;
  mobilePhone: string;
  sendType: SMSSendType;
  verifyHeader: string;
  stepType?: SMSStepType;
}
/**
 * 发送短信验证码，6位数
 *
 * @export
 * @param {SMSSendModel} smsSendModel
 * @returns
 */
export function resendSMSLoginAuthCode(smsSendModel: SMSSendModel) {
  let headers = {};
  if (smsSendModel.verifyHeader) {
    // 组装滑动验证码header
    headers = {
      Verification: smsSendModel.verifyHeader,
    };
  }
  // tslint:disable-next-line:no-commented-code
  // (headers as any).CLIENT = 'QingTui/52400;Macintosh, Intel Mac OS X 10_15_7;Web;0';
  // (headers as any).signature = 'signature';
  return RequestUtil.sendRequest({
    headers,
    url: 'login/sms/send',
    method: RequestUtil.Method.POST,
    data: smsSendModel,
  }).then((response) => {
    if (response) {
      return response.data;
    }
    return response;
  });
}

export interface LoginFormModel {
  countryCode?: string;
  phone?: string;
  authCode?: string;
  verifyHeader?: string;
}

/**
 * 短信验证登录
 *
 * @export
 * @param {LoginFormModel} loginForm
 * @returns
 */
export function smsLogin(loginForm: LoginFormModel) {
  let headers = {};
  if (loginForm.verifyHeader) {
    // 组装滑动验证码header
    headers = {
      Verification: loginForm.verifyHeader,
    };
  }
  return RequestUtil.sendRequest({
    headers,
    url: 'login/sms/verification/code/drive',
    method: RequestUtil.Method.GET,
    data: {
      countryCode: loginForm.countryCode,
      mobilePhone: loginForm.phone,
      smsAuthCode: loginForm.authCode,
      deviceType: 'tms',
    },
  });
}

// 新用户跳过登录获取轻推token
export function registerSkip(countryCode: string, mobilePhone: string) {
  return RequestUtil.sendRequest({
    url: 'account/register/default',
    method: RequestUtil.Method.POST,
    data: { countryCode, mobilePhone },
  });
}

interface RegisterBaseModel {
  countryCode: string;
  mobilePhone: string;
}
// 注册实体类
export interface RegisterSendModel extends RegisterBaseModel {
  verifyHeader: string; // 滑动验证码
}

// 验证 验证码
export interface RegisterValidateModel extends RegisterBaseModel {
  validateCode: string;
  verifyHeader?: string; // 滑动验证码
}
/**
 * 发送注册请求
 * @param resetPasswordSendModel
 */
export function sendRegisterCodeRequest(registerSendModel: RegisterSendModel) {
  return RequestUtil.sendRequest({
    url: 'account/register/code/send',
    method: RequestUtil.Method.POST,
    headers: {
      Verification: registerSendModel.verifyHeader,
    },
    data: {
      mobilePhone: registerSendModel.mobilePhone,
      countryCode: registerSendModel.countryCode,
      sso: false,
    },
  });
}

/**
 * 发送 验证验证码请求
 * @param registerValidateModel
 */
export function sendRegisterCheckRequest(registerValidateModel: RegisterValidateModel) {
  return RequestUtil.sendRequest({
    url: 'account/register/code/check',
    method: RequestUtil.Method.GET,
    headers: {
      Verification: registerValidateModel.verifyHeader || '',
    },
    data: {
      mobilePhone: registerValidateModel.mobilePhone,
      countryCode: registerValidateModel.countryCode,
      smsCode: registerValidateModel.validateCode,
    },
  });
}
